
export const AlertProductMap: {[environment:string]: string} = {
    development: 'prod_MReUPiNWP8ClWf',
    production: 'prod_MYMLx3TRAb3gkm',
}